export default __webpack_public_path__ + "static/media/roles-permission-gold.c37dd0be.svg";